
export const LINEGRAPHCONFIG = {
  type: 'line', // or 'bar', 'pie', etc.
  data: {
    labels: [],
    datasets: [{
      data: [],
      fill: true,
      borderColor: '#00599f',
      tension: 0.5
    }]
  },
  options: {
    responsive: true,
    animation: {
      duration: 0
    },
    hover: {
      animationDuration: 0
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {}
      },
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: false
        },
        ticks: {
          // callback:{function (value: any, index: any, values: any) {
          //     return formatNumber(value);
          //   }}
        }
      }
    }
  }
};



export const PIECHARTCONFIG = {
  type: 'pie', // or 'bar', 'pie', etc.
  data: {
    labels: [],
    datasets: [{
      label: 'My First Dataset',
      data: [],
      backgroundColor: [
        '#00599F',
        '#f38600'
      ]
    }]
  },
  options: {
    maintainAspectRatio: false,
    responsive: true,
    animation: {
      duration: 0
    },
    hover: {
      animationDuration: 0
    },
    scales: {
    }
    // additional options here
  }
}


export const  getGradient = (ctx: any, chartArea: any,color1:string,color2:string)=> {
  let gradient = ctx.createLinearGradient(
    0,
    chartArea.bottom,
    0,
    chartArea.top
  );
  gradient.addColorStop(0, color1);
  gradient.addColorStop(1, color2);
  return gradient;
}

export const formatNumber = (num: any)=> {
  if (num >= 10000000) {
    return (num / 10000000).toFixed(0) + ' Cr';
  } else if (num >= 100000) {
    return (num / 100000).toFixed(0) + ' Lac';
  } else {
    return num.toString();
  }
}

export const indianNumberFormat =  (value: any) => {
  let number = value.toString();
  let afterPoint = '';
  if (number.indexOf('.') > 0)
    afterPoint = number.substring(number.indexOf('.'), number.length);
  number = Math.floor(value).toString();
  let lastThree = number.substring(number.length - 3);
  let otherNumbers = number.substring(0, number.length - 3);
  if (otherNumbers !== '')
    lastThree = ',' + lastThree;
  let result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
  return result;
}